import { PlanActionTypes } from "../models/planActions";
import { CLEAR_TASK } from "../types";

export default (data: { taskIndex: number }): PlanActionTypes => ({
    type: CLEAR_TASK,
    payload: data,
});
